






















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import DatePicker from '@/components/DatePicker/DatePicker.vue';
import FilterButton from '@/components/FilterButton/FilterButton.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';

@Component({
  components: {
    ContextMenu,
    CustomSelect,
    DatePicker,
    FilterButton,
    FlexButton
  }
})
export default class Table extends Vue {
  menuVisible: boolean = false;
  selectedFilters: any[] = [];

  @Prop() title!: string;
  @Prop({ required: true }) data!: any;
  @Prop({ required: true }) sortField!: string;
  @Prop({ required: true }) sortOrder!: string;
  @Prop({ required: false }) classTitle!: string;
  @Prop() filters!: string;
  @Prop({ default: false }) loading!: string;
  @Watch('filters')
  onChange(newValue: string, oldVal: string) {
    this.setFilters(newValue);
  }

  sortChanged(field: string) {
    if (field === 'none') return;
    this.$emit('sortChanged', field);
  }

  loadMore() {
    this.$emit('loadMore');
  }

  hasSelectedFilters() {
    let has: boolean = false;
    if (!this.filters) return has;
    let keys: string[] = Object.keys(this.filters);
    if (keys)
      keys.map((key: any) => {
        if (this.filters[key].length) has = true;
      });
    return has;
  }

  private setFilters(filters: any) {
    this.selectedFilters = [];
    if (filters.date) {
      let dates: string[] = filters.date.map((value: string) => {
        if (value == '') return value;

        let date: Date = new Date(value);
        const monthNames: string[] = `${this.$t(
          'datepicker.monthNames'
        )}`.split(',');

        return `${date.getUTCDate()} ${monthNames[date.getUTCMonth()].substr(
          0,
          3
        )} ${date.getUTCFullYear()}`;
      });
      this.selectedFilters.push(dates.join(' - '));
      if (filters.date[0] === '') this.selectedFilters = [];
    }

    this.setFilter(filters);
  }

  private setFilter(itemArray: any) {
    if (!itemArray) return;

    for (const key in itemArray) {
      if (!itemArray[key]) return;
      itemArray[key].map((item: string) => this.selectedFilters.push(item));
    }
  }

  private removeFilter(filter: string, idx: number): void {
    this.$emit('filterRemoved', filter);
    this.selectedFilters.splice(idx, 1);
  }
}
